import { render, staticRenderFns } from "./ContactDropdownItem.vue?vue&type=template&id=faa43c14&scoped=true&"
import script from "./ContactDropdownItem.vue?vue&type=script&lang=js&"
export * from "./ContactDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactDropdownItem.vue?vue&type=style&index=0&id=faa43c14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa43c14",
  null
  
)

export default component.exports